/* eslint-disable tailwindcss/no-custom-classname */
import React from "react";
import { extractBodyContent } from "../build/TrainingResourceRichTextEditor";
import ReadOnlyTrainingRichTextDocument from "../../shared/ReadOnlyTrainingRichTextDocument";

interface Props {
  title: string;
  description: string;
  html: string;
}

const TrainingResourcePDFRichTextExport: React.FC<Props> = ({
  title,
  description,
  html,
}) => {
  return (
    // eslint-disable-next-line tailwindcss/no-custom-classname
    <div className="pdf-richtext-export">
      <style>{`
        @media print {
          @page {
            size: 8.5in 11in;
            margin: 1in;
          }
          body, .pdf-richtext-export {
            width: 8.5in;
            min-height: 11in;
            background: white;
          }
        }
        .pdf-richtext-export {
          width: 8.5in;
          min-height: 11in;
          margin: 0 auto;
          background: white;
          padding: 1in;
          box-sizing: border-box;
          font-family: 'Inter', Arial, sans-serif;
        }
        .pdf-richtext-export-title {
          width: 100%;
          font-size: 2rem;
          font-weight: bold;
          margin-bottom: 0.5rem;
          text-align: left;
        }
        .pdf-richtext-export-description {
          font-size: 1.1rem;
          color: #444;
          margin-bottom: 1.5rem;
          text-align: center;
        }
        .pdf-richtext-export-content {
          font-size: 1rem;
          line-height: 1.6;
        }
      `}</style>
      <div className="pdf-richtext-export-title">{title}</div>
      <div className="pdf-richtext-export-description">{description}</div>
      <div className="pdf-richtext-export-content">
        <ReadOnlyTrainingRichTextDocument text={extractBodyContent(html)} />
      </div>
    </div>
  );
};

export default TrainingResourcePDFRichTextExport;
